import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const NotFound404 = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Beklager, siden du prøvde å besøke eksisterer ikke."
      extra={
        <Link to="/">
          <Button type="primary">Tilbake hjem</Button>
        </Link>
      }
    />
  );
};

export default NotFound404;
